<template>
    <v-carousel
      v-resize="onResize"
      height="130"
      class="carousel-wrapper"
      :cycle="true"
      interval="5000"
      :hide-delimiters="delimiters"
    >
      <v-carousel-item
        v-for="(logo, logoId) in allLogos"
        :key="logoId"
        class="logo-wrapper"
      >
        <div
          v-for="(item, id) in logo"
          :key="id"
          :class="['logo', item.attr ? `-${item.attr}` : '' ]"
          :style="{ flex: item.flex }"
        >
          <img :src="item.src" :alt="item.alt" class="img">
        </div>
      </v-carousel-item>
    </v-carousel>
</template>
<script>
export default {
  props: ['divclass'],
  data: () => ({
    delimiters: false,
    allLogos: [],
    logos: [
      {
        src: '/img/partners/konsultaMD.png',
        alt: 'Konsulta',
        flex: 1,
      },
      {
        src: '/img/partners/familyDoc.png',
        alt: 'Healthway Family Clinic',
        flex: 1,
      },
      {
        src: '/img/partners/healthway.png',
        alt: 'Healthway',
        flex: 1,
      },
      {
        src: '/img/partners/generika.png',
        alt: 'Generika',
        flex: 1,
      },
      // {
      //   src: '/img/partners/mind-you.png',
      //   alt: 'Mind You',
      //   flex: 1,
      // },
      {
        src: '/img/partners/asian-square-dental.png',
        alt: 'Asian Square Dental',
        flex: 1,
      },
      {
        src: '/img/partners/mmc-gsc.png',
        alt: 'Mindanao Medical Center Inc.',
        flex: 0.5,
        attr: 'square',
      },
      {
        src: '/img/partners/mendero-medical.png',
        alt: 'Mendero Medical Center',
        flex: 1.5,
        attr: 'rectangle',
      },
      // {
      //   src: '/img/partners/lifeline.png',
      //   alt: 'Lifeline',
      //   flex: 0.5,
      //   attr: 'square',
      // },
      {
        src: '/img/partners/centro-holistico.png',
        alt: 'Centro Holistico',
        flex: 1,
      },
      {
        src: '/img/partners/brightsmile.png',
        alt: 'Bright Smile',
        flex: 1,
      },
      {
        src: '/img/partners/scelto-medico.png',
        alt: 'Scelto Medico',
        flex: 1,
      },
      {
        src: '/img/partners/family-healthcare-hospital.png',
        alt: 'Family Healthcare Hospital',
        flex: 1,
        attr: 'square',
      },
      {
        src: '/img/partners/dash-labs.png',
        alt: 'Dash Labs',
        flex: 1,
      },
      {
        src: '/img/partners/infinit-care.png',
        alt: 'Infinit Care',
        flex: 1,
      },
      // {
      //  src: '/img/partners/magis.png',
      //  alt: 'Magis Gold',
      //  flex: 1,
      // },
      {
        src: '/img/partners/peli-logo.png',
        alt: 'PELI',
        flex: 1,
      },
      {
        src: '/img/partners/prohealth.png',
        alt: 'ProHealth',
        flex: 1,
      },
    ],
  }),
  mounted() {
    this.onResize();
  },
  methods: {
    compileItems(items) {
      const content = this.logos;
      const contentNo = content.length;
      const allItem = [];
      let counter = 0;
      let container = [];

      content.forEach((item) => {
        counter += 1;
        container.push(item);

        if (counter % items === 0 || contentNo === counter) {
          allItem.push(container);
          container = [];
        }
      });

      this.allLogos = allItem;
    },
    onResize() {
      // Choose the how many items per slide.
      let display = 5;
      this.delimiters = false;

      if (window.innerWidth >= (1161)) display = 5;
      if (window.innerWidth <= (1160)) display = 4;
      if (window.innerWidth <= (768)) display = 3;
      if (window.innerWidth <= (540)) {
        display = 2;
        this.delimiters = true;
      }
      if (window.innerWidth <= (375)) display = 1;

      this.compileItems(display);
    },
  },
};
</script>
